import React, { Component } from "react";

import { Box, CircularProgress } from "@material-ui/core";
import { AxlButton, AxlModal, AxlPanel } from "axl-reactjs-ui";
import _ from "lodash";
import { inject, observer } from "mobx-react";
import moment from "moment";
import PropTypes from "prop-types";
import { Link, Route, Switch, withRouter } from "react-router-dom";
import styles from "./styles";

// Components
import AxlDialog from "../../AxlDialog";
import AxlMuiButton from "../../AxlMuiButton";
import ShipmentValueInfo from "../../ShipmentValueInfo";
import ShipmentDropoffInfo from "../ShipmentDropoffInfo";
import ShipmentEditForm from "../ShipmentEditForm/";
import ShipmentPickupInfo from "../ShipmentPickupInfo";

@inject('jobStore', 'userStore')
@observer
class ShipmentInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showShipmentEditForm: false,
      showDeleteModal: false,
    };
    this.viewShipmentById = this.viewShipmentById.bind(this);
  }

  openForm = (name) => () => {
    const formStateName = `show${name}Form`;
    this.setState({ [formStateName]: true });
  };

  closeForm = (name) => () => {
    const formStateName = `show${name}Form`;
    this.setState({ [formStateName]: false });
  };

  viewShipmentById(shipment) {
    if (!shipment || !shipment.id || !shipment.dropoff_earliest_ts)
      return false;

    this.props.history.push(
      `/deliveries/${moment(shipment.dropoff_earliest_ts).format(
        "YYYY-MM-DD"
      )}/all/${shipment.id}`
    );
  }

  deleteShipment = () => {
    const { jobStore, history } = this.props;
    const { selectedJob, selectedShipment } = jobStore;
    if (!selectedJob || !selectedShipment) return;

    jobStore.deleteDraftShipment(selectedJob.id, selectedShipment.id, (res) => {
      if (res.ok) {
        this.setState({ showDeleteModal: false });
        history.replace(`/batch/${selectedJob.id}`);
      }
    });
  };

  render() {
    const { showShipmentEditForm, showDeleteModal } = this.state;
    const { jobStore, isBlur } = this.props;
    const { selectedShipment, selectedJob, deletingShipment } = jobStore;

    if (!selectedShipment) return null;

    const { customer } = selectedShipment;
    const isDraftJob =
      selectedJob?.status && jobStore?.isDraftJob(selectedJob?.status);

    return (
      <AxlPanel style={styles.container}>
        <AxlPanel.Row col={true} style={{ width: "100%", height: "100%" }}>
          <AxlPanel.Col
            flex={0}
            style={{ padding: "15px 20px 0", marginBottom: "15px" }}
          >
            <AxlPanel.Row>
              {isDraftJob && (
                <AxlMuiButton
                  style={{backgroundColor: 'red'}}
                  onClick={() => this.setState({ showDeleteModal: true })}
                  label={'Delete'}
                />
              )}
              <AxlPanel.Col
                center
                style={{ paddingLeft: "15px", paddingRight: "15px" }}
              >
                <div style={{ ...styles.name, ...(isBlur && styles.textBlur) }}>
                  {customer && customer.name ? customer.name : ""}
                </div>
              </AxlPanel.Col>
              {isDraftJob ? (
                <AxlButton
                  tiny
                  bg={`none`}
                  onClick={this.openForm("ShipmentEdit")}
                >{`Edit`}</AxlButton>
              ) : (
                <AxlButton
                  tiny
                  bg={`blueGray`}
                  onClick={() => this.viewShipmentById(selectedShipment)}
                >{`View in Shipments`}</AxlButton>
              )}
            </AxlPanel.Row>
            <AxlPanel.Row style={{ marginTop: "15px" }}>
              <AxlPanel.Col>
                <AxlPanel.Row>
                  <AxlPanel.Col>
                    <div style={styles.label2}>{`Customer Info:`}</div>
                    <div
                      style={{
                        ...styles.email,
                        ...(isBlur && styles.textBlur),
                      }}
                    >
                      {customer && customer.email ? customer.email : ""}
                    </div>
                  </AxlPanel.Col>
                </AxlPanel.Row>
              </AxlPanel.Col>
              <AxlPanel.Col style={styles.email}>
                <div style={styles.label2}>
                  <br />
                </div>
                <div
                  style={{ ...styles.phone, ...(isBlur && styles.textBlur) }}
                >
                  {customer && customer.phone_number
                    ? customer.phone_number
                    : ""}
                </div>
              </AxlPanel.Col>
            </AxlPanel.Row>
          </AxlPanel.Col>
          <AxlPanel.Col
            flex={1}
            style={{ padding: "0 20px", height: "100%", overflowY: "scroll" }}
          >
            <ShipmentValueInfo shipment={selectedShipment} />
            <ShipmentPickupInfo shipment={selectedShipment} />
            <ShipmentDropoffInfo shipment={selectedShipment} />
          </AxlPanel.Col>
        </AxlPanel.Row>
        {showShipmentEditForm && (
          <AxlModal
            onClose={this.closeForm("ShipmentEdit")}
            style={styles.shipmentEditModal}
          >
            <ShipmentEditForm closeForm={this.closeForm("ShipmentEdit")} />
          </AxlModal>
        )}
        {showDeleteModal && (
          <AxlDialog
            isOpen={showDeleteModal}
            handleClose={() => this.setState({ showDeleteModal: false })}
            maxWidth="xs"
            children={"Are you sure to delete this shipment? This cannot be undone."}
            childrenTitle={"DELETE SHIPMENT"}
            childrenAction={
              <Box>
                <AxlMuiButton
                  label="CANCEL"
                  variant="outlined"
                  style={{marginRight: 8, backgroundColor: '#fff', color: '#000'}}
                  onClick={() => this.setState({ showDeleteModal: false })}
                  disabled={deletingShipment}
                />

                <AxlMuiButton
                  label={deletingShipment ? <CircularProgress size={20} color="#fff"/> : "DELETE"}
                  onClick={this.deleteShipment}
                  disabled={deletingShipment}
                  style={{backgroundColor: 'red'}}
                />
              </Box>
            }
          />
        )}
      </AxlPanel>
    );
  }
}

ShipmentInfo.defaultProps = {
  isEdit: true,
};

ShipmentInfo.propTypes = {
  isEdit: PropTypes.bool,
};

export default withRouter(ShipmentInfo);
